"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Const
 */
var enviroment_vars_1 = require("./enviroment.vars");
Object.defineProperty(exports, "API_UPLOAD", { enumerable: true, get: function () { return enviroment_vars_1.API_UPLOAD; } });
/**
 * Components
 */
var FileUpload_1 = require("./components/FileUpload");
Object.defineProperty(exports, "FileUpload", { enumerable: true, get: function () { return FileUpload_1.FileUpload; } });
var UploadButton_1 = require("./components/UploadButton");
Object.defineProperty(exports, "UploadButton", { enumerable: true, get: function () { return UploadButton_1.UploadButton; } });
/**
 * Hooks
 */
var hooks_1 = require("./hooks");
Object.defineProperty(exports, "useDeleteFiles", { enumerable: true, get: function () { return hooks_1.useDeleteFiles; } });
Object.defineProperty(exports, "useUploadFiles", { enumerable: true, get: function () { return hooks_1.useUploadFiles; } });
Object.defineProperty(exports, "useFormDataAPICallAsync", { enumerable: true, get: function () { return hooks_1.useFormDataAPICallAsync; } });
Object.defineProperty(exports, "useRenderableImage", { enumerable: true, get: function () { return hooks_1.useRenderableImage; } });
Object.defineProperty(exports, "useFileReaderJSON", { enumerable: true, get: function () { return hooks_1.useFileReaderJSON; } });
/**
 * functions
 */
var functions_1 = require("./functions");
Object.defineProperty(exports, "createFormDataApiCall", { enumerable: true, get: function () { return functions_1.createFormDataApiCall; } });
Object.defineProperty(exports, "getExtension", { enumerable: true, get: function () { return functions_1.getExtension; } });
Object.defineProperty(exports, "createDownloadFile", { enumerable: true, get: function () { return functions_1.createDownloadFile; } });
//# sourceMappingURL=index.js.map